const WEB_SERVICE_URIS = {
  github: 'github.com',
  twitter: 'twitter.com',
  facebook: 'facebook.com',
  linkedin: 'linkedin.com',
  instagram: 'instagram.com',
};

export class WebService {
  private snsUrl: URL = null;

  constructor(private originalUrl: string) {
    this.snsUrl = new URL(originalUrl);
  }

  path() {
    const path = this.snsUrl.pathname;
    return path.startsWith('/')
      ? // strip first '/
        path.substring(1)
      : path;
  }

  serviceName() {
    const host = this.snsUrl.host;
    const name = Object.keys(WEB_SERVICE_URIS).find(k => host.includes(k));
    return name || null;
  }

  isGithub() {
    return this.snsUrl.host.includes('github.com');
  }

  isTwitter() {
    return this.snsUrl.host.includes('twitter.com');
  }

  isFacebook() {
    return this.snsUrl.host.includes('facebook.com');
  }

  isLinkedin() {
    return this.snsUrl.host.includes('linkedin.com');
  }

  isInstagram() {
    return this.snsUrl.host.includes('instagram.com');
  }
}
